import {SEARCH_ZOHO_CUSTOMERS} from "@/store/actions.type";
import {ZohoService} from "@/common/api";

const state = {};

const getters = {};

const actions = {
	async [SEARCH_ZOHO_CUSTOMERS]({commit}, searchWord) {
		return ZohoService.searchCustomers(searchWord)
			.then(({data}) => {
				return data;
			})
			.catch(error => {
				throw new Error(error);
			})
	}
};

const mutations = {};

export default {
	state,
	getters,
	actions,
	mutations
};